export default {
    getHeaderFields: state => state.headerFields,
    getFeuPartnerManagerHeaderFields: state => state.headerFieldsFeuPartnerManager,
    getDataTableOptions: state => state.dataTableOptions,
    getRowActions: state => state.rowActions,
    getActions: state => state.actions,
    getSearchFields: state => state.searchFields,
    getFeuPartnerManagerSearchFields: state => state.searchFieldsFeuPartnerManager
}
